import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";

import { Dialog, DialogContent, IconButton, Stack, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import RotateRightIcon from "@mui/icons-material/RotateRight";

const useStyles = makeStyles((theme) => ({
  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: "auto", // Redimensionar automaticamente a altura para manter a proporção
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
}));

const ModalImageCors = ({ imageUrl }) => {
  const classes = useStyles();
  const [fetching, setFetching] = useState(true);
  const [blobUrl, setBlobUrl] = useState("");

  const [open, setOpen] = useState(false);
  const [rotation, setRotation] = useState(0);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setRotation(0); // resetar rotação ao fechar
    setOpen(false);
  };

  //   useEffect(() => {
  //     if (!imageUrl) return;
  //     const fetchImage = async () => {
  //       const { data, headers } = await api.get(imageUrl, {
  //         responseType: "blob",
  //       });
  //       const url = window.URL.createObjectURL(
  //         new Blob([data], { type: headers["content-type"] })
  //       );
  //       setBlobUrl(url);
  //       setFetching(false);
  //     };
  //     fetchImage();
  //   }, [imageUrl]);

  useEffect(() => {
    if (!imageUrl) return;
    const fetchImage = async () => {
      const { data, headers } = await api.get(imageUrl, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([data], { type: headers["content-type"] })
      );
      setBlobUrl(url);
      setFetching(false);
    };
    fetchImage();
  }, [imageUrl]);

  const handleDownload = async () => {
    try {
      const response = await fetch(imageUrl, {
        mode: "cors", // pode ser omitido se for mesma origem
      });

      if (!response.ok) throw new Error("Erro ao baixar imagem");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "imagem.jpg"; // você pode usar Date.now() + extensão também
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // libera memória
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Erro ao baixar imagem:", err);
      alert("Erro ao baixar a imagem. Verifique se o link está acessível.");
    }
  };

  const handleRotate = () => {
    setRotation((prev) => (prev + 90) % 360);
  };
  return (
    // <ModalImage
    // 	className={classes.messageMedia}
    // 	smallSrcSet={fetching ? imageUrl : blobUrl}
    // 	medium={fetching ? imageUrl : blobUrl}
    // 	large={fetching ? imageUrl : blobUrl}
    // 	alt="image"
    // 	showRotate={true}
    // />
    <>
      {/* ------------------------ PATRICK IMAGEM DA CONVERSA ------------------------ */}
      <img
        src={imageUrl}
        alt="Miniatura"
        onClick={handleOpen}
        style={{
          width: "200px",
          height: "auto",
          borderRadius: "6px",
          cursor: "pointer",
          marginBottom: "5px",
        }}
      />

      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <Box style={{ position: "relative" }}>
          {/* Botão Fechar */}
          <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#fff",
              backgroundColor: "rgba(0,0,0,0.5)",
              borderRadius: "50%",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Botões de ação */}
          <Stack
            direction="row"
            spacing={1}
            style={{
              position: "absolute",
              top: 8,
              left: 8,
              zIndex: 10,
            }}
          >
            {/* Botão Baixar */}
            <IconButton
              onClick={handleDownload}
              style={{
                color: "#fff",
                backgroundColor: "rgba(0,0,0,0.5)",
                borderRadius: "50%",
              }}
            >
              <DownloadIcon />
            </IconButton>

            {/* Botão Girar */}
            <IconButton
              onClick={handleRotate}
              style={{
                color: "#fff",
                backgroundColor: "rgba(0,0,0,0.5)",
                borderRadius: "50%",
              }}
            >
              <RotateRightIcon />
            </IconButton>
          </Stack>

          {/* Imagem */}
          <DialogContent
            style={{
              textAlign: "center",
              padding: "1rem",
              backgroundColor: "#000",
            }}
          >
            <img
              src={imageUrl}
              alt="Visualização"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                borderRadius: "10px",
                transform: `rotate(${rotation}deg)`,
                transition: "transform 0.3s ease",
              }}
            />
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};

export default ModalImageCors;
